@file:OptIn(InternalResourceApi::class)

package crossly.webapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/crossly.webapp.generated.resources/"

@delegate:ResourceContentHash(-1_065_186_115)
internal val Res.font.noto_color_emoji_subset: FontResource by lazy {
      FontResource("font:noto_color_emoji_subset", setOf(
        ResourceItem(setOf(), "${MD}font/noto_color_emoji_subset.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_230_448_560)
internal val Res.font.noto_sans_math_subset: FontResource by lazy {
      FontResource("font:noto_sans_math_subset", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_math_subset.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-178_315_553)
internal val Res.font.noto_sans_symbols2_subset: FontResource by lazy {
      FontResource("font:noto_sans_symbols2_subset", setOf(
        ResourceItem(setOf(), "${MD}font/noto_sans_symbols2_subset.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("noto_color_emoji_subset", Res.font.noto_color_emoji_subset)
  map.put("noto_sans_math_subset", Res.font.noto_sans_math_subset)
  map.put("noto_sans_symbols2_subset", Res.font.noto_sans_symbols2_subset)
}
